"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");

var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = Label;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useListBox3 = _interopRequireDefault(require("../../useListBox"));

var _PropsProvider = require("../../store/PropsProvider");

var sc = _interopRequireWildcard(require("./Label.styles"));

var _LabelMulti = _interopRequireDefault(require("./LabelMulti"));

var _LabelSingle = _interopRequireDefault(require("./LabelSingle"));

var _excluded = ["hasImplicitAll", "placeholder", "label", "isDisabled"];

function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function Label(props) {
  var hasImplicitAll = props.hasImplicitAll,
      placeholder = props.placeholder,
      customLabel = props.label,
      isDisabled = props.isDisabled,
      moreProps = (0, _objectWithoutProperties2["default"])(props, _excluded);

  var _useListBox = (0, _useListBox3["default"])(),
      _useListBox2 = (0, _slicedToArray2["default"])(_useListBox, 1),
      state = _useListBox2[0];

  var selectedOptions = state.selectedOptions,
      isMulti = state.isMulti,
      options = state.options;

  var _React$useContext = _react["default"].useContext(_PropsProvider.PropsContext),
      isReadOnly = _React$useContext.isReadOnly;

  var _React$useState = _react["default"].useState(placeholder),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      label = _React$useState2[0],
      setLabel = _React$useState2[1];

  _react["default"].useEffect(function () {
    if (selectedOptions.length) {
      var _label = isMulti ? /*#__PURE__*/_react["default"].createElement(_LabelMulti["default"], {
        options: options,
        selectedOptions: selectedOptions
      }) : /*#__PURE__*/_react["default"].createElement(_LabelSingle["default"], {
        options: options,
        selectedOptions: selectedOptions
      });

      setLabel(_label);
      return;
    }

    setLabel(placeholder);
  }, [isMulti, options, placeholder, selectedOptions]);

  return /*#__PURE__*/_react["default"].createElement(sc.Label, (0, _extends2["default"])({}, moreProps, {
    hasImplicitAll: hasImplicitAll,
    isPlaceholder: !selectedOptions.length,
    isDisabled: isDisabled,
    isReadOnly: isReadOnly
  }), customLabel || label);
}

Label.propTypes = {
  hasImplicitAll: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,

  /** Override the label with a custom one. */
  label: _propTypes["default"].string,

  /** Sets a placeholder for the label. */
  placeholder: _propTypes["default"].string
};
Label.defaultProps = {
  hasImplicitAll: false,
  isDisabled: false,
  label: null,
  placeholder: ""
};
//# sourceMappingURL=Label.js.map